import { Component, OnInit } from '@angular/core';
import {ApiRestService} from "../api-rest.service";
import {Scorta} from "../_Models";

@Component({
  selector: 'app-scorte-list',
  templateUrl: './scorte-list.component.html'
})
export class ScorteListComponent implements OnInit {
  scorte: Scorta;
  anno:number = new Date().getFullYear();
  inizioMese = new Date(this.anno, new Date().getMonth(), 1);
  fineMese = new Date(this.anno, new Date().getMonth(), 1).setMonth(this.inizioMese.getMonth() + 6);
  inizio = this.datepipe.transform( this.inizioMese,'yyyy-MM-dd');
  fine = this.datepipe.transform(this.fineMese, 'yyyy-MM-dd');
  Filtri: {inizio, fine, prodotto, prodotto_id} =  {inizio: this.inizio, fine: this.fine, prodotto: '', prodotto_id: undefined};
  constructor (
    private apirestservice: ApiRestService,
    private datepipe: DatePipe,
    public permission: Permission,
  ) {}

  ngOnInit(): void {
    this.refresh();
  }
  refresh(prodottoid?, item?){
    this.Filtri.prodotto_id = prodottoid;
    this.apirestservice.PrimaNotaScorteList(this.Filtri).subscribe(data=> {
      if (!prodottoid)
        this.scorte = data;
      else if(item && data?.data?.length>0) {
        const idx = this.scorte?.data?.findIndex(x => x.id == item.id);
        if(idx > -1)
          this.scorte.data[idx] = data?.data[0];
      }
    });
  }

  InputBlur(i: {label:string, value, edit: boolean, visible: boolean}[], item) {
    console.log(i)
    console.log(item)
    let _temp = {};
    i.forEach(x=>{
      _temp[x.label] = x.value;
    })
    if(_temp['id'])
      this.apirestservice.PrimaNotaScorteUpdate(_temp).subscribe(() => this.refresh(_temp['prodotto_id'],item));
    else
      this.apirestservice.PrimaNotaScorteAdd(_temp).subscribe(() => this.refresh(_temp['prodotto_id'],item));
  }
}
import { Pipe, PipeTransform } from '@angular/core';
import {DatePipe} from "@angular/common";
import {Permission} from "../../Login/_guards/Permission";

@Pipe({
  name: 'enabledFilter',
  pure: false
})
export class FilterEnabled implements PipeTransform {
  transform(items: any[], filter: boolean): any {
    if (!items || !filter) {
      return items;
    }
    return items.filter(item => item.visible);
  }
}
